export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_OPPORTUNITIES = 'SET_OPPORTUNITIES';
export const SET_INVESTMENTS = 'SET_INVESTMENTS';
export const SET_INVESTMENT_SHOW = 'SET_INVESTMENT_SHOW';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const SET_OPPORTUNITY_SHOW = 'SET_OPPORTUNITY_SHOW';
export const STORE_WISH = 'STORE_WISH';
export const STORE_LOGIN_EMAIL = 'STORE_LOGIN_EMAIL';
export const SET_CURRENT_OVERLAY_FILE = 'SET_CURRENT_OVERLAY_FILE';
export const OPEN_FILE_VIEWER = 'OPEN_FILE_VIEWER';
export const CLOSE_FILE_VIEWER = 'CLOSE_FILE_VIEWER';
export const SET_INVESTMENT_ENTITIES = 'SET_INVESTMENT_ENTITIES';
export const SET_INVESTMENT_ENTITY = 'SET_INVESTMENT_ENTITY';
export const RESET = 'RESET';
export const SET_ALERT = 'SET_ALERT';
export const UPDATE_REGISTRATION_NUMBER = 'UPDATE_REGISTRATION_NUMBER';
export const UPDATE_FORM_FROM_API = 'UPDATE_FORM_FROM_API';
export const SET_USER = 'SET_USER';
export const DISPLAY_KYC_BANNER = 'DISPLAY_KYC_BANNER';
export const RESET_BANNER = 'RESET_BANNER';
export const VALIDATE_KYC_INTRODUCTION = 'VALIDATE_KYC_INTRODUCTION';
export const SET_KYC = 'SET_KYC';
export const SET_KYCS = 'SET_KYCS';
export const SET_KNOWLEDGE_QUESTIONS = 'SET_KNOWLEDGE_QUESTIONS';
export const SET_GOAL_QUESTIONS = 'SET_GOAL_QUESTIONS';
export const SET_KNOWLEDGE_ANSWER = 'SET_KNOWLEDGE_ANSWER';
export const SET_GOAL_ANSWER = 'SET_GOAL_ANSWER';
export const DISPLAY_VALIDATED_KYC_BANNER = 'DISPLAY_VALIDATED_KYC_BANNER';
export const SET_DOCUSIGN_URL = 'SET_DOCUSIGN_URL';
export const RESET_PROOF_OF_ADDRESS = 'RESET_PROOF_OF_ADDRESS';
export const RESET_IDENTITY_DOCUMENT = 'RESET_IDENTITY_DOCUMENT';
export const SET_CAPTABLE_URL = 'SET_CAPTABLE_URL';
